import Button from '@components/button/Button';

import { TimeLineErrorProps } from '../../types/leadActivity';

const TimeLineError = ({ handleRefetch }: TimeLineErrorProps) => (
  <div className="flex flex-col items-center justify-center bg-white p-6">
    <div className="mb-4 text-red-500">Failed to load timeline data</div>
    <Button
      handleClick={handleRefetch}
      label="Retry"
      variant="primary"
      size="medium"
    />
  </div>
);

export default TimeLineError;
